/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async listTags() {
    let data = { source: "Web" };
    let response = await apiCall("tag/list", data);
    return response;
  },

  async addTag(tagName, description, color) {
    let data = {
      tag_name: tagName,
      description: description,
      color
    };
    let response = await apiCall("tag/create", data);
    return response;
  },

  async filterTags(page) {
    let data = { page: page };
    let response = await apiCall("tag/filter", data);
    return response;
  },

  async importTags(importFile) {
    let data = { tags_file: importFile };
    let response = await apiCall("tag/import", data);
    return response;
  },

  async fetchTagCount() {
    let response = await apiCall("tag/tag/count", []);
    return response;
  },

  async addProject(data){
    return await apiCall("tag/project/create_project", data);
  },
  async updateProject(data){
    return await apiCall("tag/project/update_project", data);
  }
};
